import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Callout } from 'seagull';
import { openInNewTabProps } from '~/constants';
import { useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
import styles from './HomePage.module.scss';
export function MissingColumnBankAccountBanner() {
    const { t: homeTexts } = useLocaleKeys('pages.homePage');
    const showMissingColumnBankAccountBanner = useStore(selectors.showMissingColumnBankAccountBanner);
    return showMissingColumnBankAccountBanner ? /*#__PURE__*/ _jsx(Callout, {
        hideIcon: true,
        intent: "warning",
        testId: "missing-column-bank-account-banner",
        className: styles.missingColumnBankAccountBanner,
        withAction: /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
            bi: {
                name: 'schedule_ach_migration_call'
            },
            as: "a",
            href: "https://book.avoma.com/anchor/3-day-ach-migration",
            skin: "darkSecondary"
        }, openInNewTabProps), {
            children: homeTexts.scheduleCall()
        })),
        children: homeTexts.missingColumnBankAccountMessage()
    }) : null;
}
